import apiClient from "../../utils/apiClient";

export const apiPurchasedProduct = (dataRequest) => {
  return apiClient
    .post("/api/v1/purchased-product", dataRequest["data"])
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return Promise.reject(error);
    });
};

export const apiPurchasedProductUploadImage = (formData) => {
  return apiClient
    .post("/api/v1/purchased-product-upload-image", formData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    })
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return Promise.reject(error);
    });
};
